export const SUCCESS = "SUCCESS_SWITCH";
export const ERROR = "ERROR_SWITCH";
export const CLEAR = "CLEAR_SWITCH";
export const LOADING = "LOADING_SWITCH";

export const GET_STATUS = "GET_STATUS_SWITCH";

export function loading(loading = true) {
	return {
		type: LOADING,
		data: loading
	};
}

export function error(error) {
	return {
		type: ERROR,
		data: error
	};
}


export function success() {
	return {
		type: SUCCESS,
	};
}

export function clear() {
	return {
		type: CLEAR
	};
}

export function getStatusCreator(status) {
	return {
		type: GET_STATUS,
		data: status
	};
}